<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form :model="where" label-width="77px" class="ele-form-search"
        @keyup.enter.native="reload" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="财务名称">
              <el-select clearable filterable class="ele-block" v-model="where.finance_id" placeholder="请选择">
                <el-option v-for="item in financeList" :key="item.id" :value="item.id" :label="item.username" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="收款信息">
              <el-select clearable filterable allow-create class="ele-block" v-model="where.account_name"
                placeholder="请选择">
                <el-option v-for="item in accountNameList" :key="item.id" :value="item.id"
                  :label="item.account_name_value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="7" :md="12">
            <el-form-item label="选择时间">
              <el-date-picker v-model="where.time" type="daterange" range-separator="至"
                start-placeholder="开始日期" value-format="yyyy-MM-dd" end-placeholder="结束日期" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="审核状态">
              <el-select clearable class="ele-block" v-model="where.audit_status" placeholder="全部">
                <el-option v-for="item in auditStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <ele-pro-table ref="table" :where="where" row-key="id" :datasource="url" :columns="columns"
        :selection.sync="selection" height="calc(100vh - 315px)">
        <template slot="toolbar">
          <template v-if="permission.includes('sys:recolumn:add')">
            <el-button v-for="item in addTypeButtons" :key="item.typeCode" size="small" type="primary"
              icon="el-icon-plus" class="ele-btn-icon" @click="openAdd(item.typeCode)">{{ item.label }}</el-button>
          </template>
          <el-button size="small" type="warning" icon="el-icon-s-finance" class="ele-btn-icon"
            :disabled="!selection.length" @click="openRiskLimitBatch"
            v-if="permission.includes('sys:recolumn:edit')">批量风控</el-button>
          <el-button size="small" type="danger" icon="el-icon-delete" class="ele-btn-icon"
            :disabled="!selection.length" @click="removeBatch"
            v-if="permission.includes('sys:recolumn:dall')">删除</el-button>
          <el-button size="small" type="warning" icon="el-icon-refresh" class="ele-btn-icon"
            @click="initData" v-if="permission.includes('sys:recolumn:edit')">初始化</el-button>
        </template>

        <template slot="action" slot-scope="{ row }">
          <template v-if="Number(row.audit_status) === 0">
            <el-button size="small" type="success" class="ele-btn-icon" @click="auditPass(row)"
              v-if="permission.includes('sys:recolumn:edit')">通过</el-button>
            <el-button size="small" type="warning" class="ele-btn-icon" @click="auditReject(row)"
              v-if="permission.includes('sys:recolumn:edit')">拒绝</el-button>
          </template>
          <template v-else-if="Number(row.audit_status) === 2">
            <el-button size="small" type="primary" class="ele-btn-icon" @click="openDetail(row)">详情</el-button>
            <el-popconfirm class="ele-action" title="确定要删除此收款信息吗？" @confirm="remove(row)"
              v-if="permission.includes('sys:recolumn:delete')">
              <el-button size="small" type="danger" class="ele-btn-icon" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
          <template v-else>
            <el-button size="small" type="primary" class="ele-btn-icon" @click="openEdit(row)"
              v-if="permission.includes('sys:recolumn:edit')">编辑</el-button>
            <el-button size="small" type="primary" class="ele-btn-icon" @click="openEdit2(row)"
              v-if="permission.includes('sys:recolumn:edit')">校准</el-button>
            <el-button size="small" type="warning" class="ele-btn-icon" @click="openRiskLimit(row)"
              v-if="permission.includes('sys:recolumn:edit')">风控</el-button>
            <el-popconfirm class="ele-action" title="确定要删除此银行卡吗？" @confirm="remove(row)"
              v-if="permission.includes('sys:recolumn:delete')">
              <el-button size="small" type="danger" class="ele-btn-icon" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </template>

        <template slot="audit_status" slot-scope="{ row }">
          <dict-tag dict-code="audit_status" :value="row.audit_status" />
        </template>

        <template slot="status_up" slot-scope="{ row }">
          <span
            class="dict-cell-clickable"
            :class="{ 'is-disabled': Number(row.audit_status) !== 1 || !permission.includes('sys:recolumn:status') }"
            @click="Number(row.audit_status) === 1 && permission.includes('sys:recolumn:status') && toggleStatusUp(row)">
            <dict-tag dict-code="online_status" :value="row.status_up" />
          </span>
        </template>
      </ele-pro-table>
    </el-card>

    <recolumn-edit-bank
      v-if="showEdit && activeEditType === '1'"
      :visible.sync="showEdit"
      :data="editData"
      :finance-list="financeList"
      type-code="1"
      @done="onEditDone" />
    <recolumn-edit-wechat
      v-if="showEdit && activeEditType === '2'"
      :visible.sync="showEdit"
      :data="editData"
      :finance-list="financeList"
      type-code="2"
      @done="onEditDone" />
    <recolumn-edit-alipay
      v-if="showEdit && activeEditType === '3'"
      :visible.sync="showEdit"
      :data="editData"
      :finance-list="financeList"
      type-code="3"
      @done="onEditDone" />
    <recolumn-edit-to :data="current2" :visible.sync="showEdit2" @done="reload" />

    <el-dialog
      :title="riskForm.batch ? '批量设置风控上限' : '风控上限'"
      :visible.sync="showRiskLimit"
      width="480px"
      :destroy-on-close="true"
      append-to-body>
      <el-form ref="riskForm" :model="riskForm" :rules="riskRules" label-width="100px" @submit.native.prevent>
        <template v-if="!riskForm.batch">
          <el-form-item label="收款账号">
            <el-input :value="riskForm.account_label" disabled />
          </el-form-item>
          <el-form-item label="实际余额">
            <el-input :value="riskForm.sj_amount_to" disabled />
          </el-form-item>
        </template>
        <el-form-item label="风控上限" prop="risk_limit">
          <el-input v-model.trim="riskForm.risk_limit" clearable maxlength="16" placeholder="实际余额达到该金额自动下线，0为关闭">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <div class="ele-text-secondary" style="margin: -6px 0 8px 100px; font-size: 12px;">
          实际余额 ≥ 风控上限时，系统自动将该收款账号下线
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="showRiskLimit = false">取消</el-button>
        <el-button type="primary" :loading="riskSaving" @click="saveRiskLimit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="收款信息详情" :visible.sync="showDetail" width="560px" :destroy-on-close="true" append-to-body>
      <el-descriptions v-if="detailData" :column="1" border size="small">
        <el-descriptions-item label="财务名称">{{ detailData.finance_name || '未关联财务' }}</el-descriptions-item>
        <el-descriptions-item label="收款名称">{{ detailData.account_name }}</el-descriptions-item>
        <el-descriptions-item label="银行/渠道">{{ detailData.bank_name }}</el-descriptions-item>
        <el-descriptions-item label="账号">{{ detailData.account_number }}</el-descriptions-item>
        <el-descriptions-item label="分行">{{ detailData.branch_name }}</el-descriptions-item>
        <el-descriptions-item label="余额">{{ detailData.sj_amount_to || detailData.sj_amount || '0.00' }}</el-descriptions-item>
        <el-descriptions-item label="审核状态">已拒绝</el-descriptions-item>
        <el-descriptions-item label="拒绝原因">{{ detailData.audit_remark }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">
          {{ detailData.audit_time ? $util.toDateString(detailData.audit_time) : undefined }}
        </el-descriptions-item>
        <el-descriptions-item v-if="detailData.qr_image" label="二维码">
          <img :src="detailData.qr_image" alt="qr" style="width: 96px; height: 96px; object-fit: cover; border-radius: 6px;" />
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="showDetail = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getDictData, loadDictOptions } from '@/utils/dict';
import RecolumnEditBank from './recolumn-edit-bank.vue';
import RecolumnEditAlipay from './recolumn-edit-alipay.vue';
import RecolumnEditWechat from './recolumn-edit-wechat.vue';
import RecolumnEditTo from './recolumn-edit-to.vue';

const TYPE_DIALOG = {
  '1': 'bank',
  '2': 'wechat',
  '3': 'alipay'
};

export default {
  name: 'Resourcecolumn',
  components: { RecolumnEditBank, RecolumnEditAlipay, RecolumnEditWechat, RecolumnEditTo },
  computed: {
    ...mapGetters(['permission']),
    addTypeButtons() {
      const list = (this.typeNameList || [])
        .filter((d) => TYPE_DIALOG[String(d.dictDataCode)])
        .map((d) => ({
          typeCode: String(d.dictDataCode),
          label: d.dictDataName || d.name || d.dictDataCode
        }));
      if (list.length) {
        return list.sort((a, b) => Number(a.typeCode) - Number(b.typeCode));
      }
      return [
        { typeCode: '1', label: '银行' },
        { typeCode: '2', label: '微信' },
        { typeCode: '3', label: '支付宝' }
      ];
    }
  },
  data() {
    return {
      url: '/resourcecolumn/index',
      columns: [
        { columnKey: 'selection', type: 'selection', width: 45, align: 'center', fixed: 'left' },
        { prop: 'id', label: '序号', width: 60, align: 'center', showOverflowTooltip: true, fixed: 'left' },
        {
          prop: 'finance_name',
          label: '财务名称',
          showOverflowTooltip: true,
          minWidth: 110,
          align: 'center',
          formatter: (row, column, cellValue) => cellValue || '未关联财务'
        },
        { prop: 'day_count', label: '今日收款', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'sj_amount_to', label: '实际余额', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        {
          prop: 'risk_limit',
          label: '风控上限',
          showOverflowTooltip: true,
          minWidth: 100,
          align: 'center',
          formatter: (row, column, cellValue) => {
            const n = Number(cellValue);
            return !n ? '未设置' : Number(n).toFixed(2);
          }
        },
        {
          prop: 'account_info',
          label: '收款信息',
          showOverflowTooltip: true,
          minWidth: 240,
          align: 'center',
          formatter: (row) => {
            const base = [row.account_name, row.bank_name, row.account_number].filter(Boolean).join(' | ');
            return row.qr_code ? `${base} 码` : base;
          }
        },
        { prop: 'audit_status', label: '审核状态', align: 'center', width: 100, resizable: false, slot: 'audit_status' },
        { prop: 'status_up', label: '在线状态', align: 'center', width: 100, resizable: false, slot: 'status_up' },
        {
          prop: 'create_time',
          label: '创建时间',
          sortable: 'custom',
          showOverflowTooltip: true,
          minWidth: 160,
          align: 'center',
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        },
        {
          prop: 'update_time',
          label: '更新时间',
          sortable: 'custom',
          showOverflowTooltip: true,
          minWidth: 160,
          align: 'center',
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        },
        { columnKey: 'action', label: '操作', width: 280, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
      ],
      where: {
        finance_id: '',
        account_name: '',
        time: '',
        audit_status: ''
      },
      selection: [],
      accountNameList: [],
      financeList: [],
      typeNameList: [],
      activeEditType: '',
      editData: null,
      showEdit: false,
      current2: null,
      showEdit2: false,
      showDetail: false,
      detailData: null,
      auditStatusOptions: [],
      showRiskLimit: false,
      riskSaving: false,
      riskForm: {
        batch: false,
        id: 0,
        ids: [],
        account_label: '',
        sj_amount_to: '',
        risk_limit: ''
      },
      riskRules: {
        risk_limit: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '' || value === null || value === undefined) {
                callback(new Error('请输入'));
                return;
              }
              if (!/^\d+(\.\d{1,2})?$/.test(String(value))) {
                callback(new Error('请输入正确金额，最多两位小数'));
                return;
              }
              callback();
            },
            trigger: 'blur'
          }
        ]
      }
    };
  },
  mounted() {
    this.getResourceName();
    this.queryFinance();
    Promise.all([
      getDictData('online_status'),
      getDictData('type_name'),
      loadDictOptions('audit_status', { numberValue: true })
    ]).then(([, typeList, auditList]) => {
      this.typeNameList = typeList || [];
      this.auditStatusOptions = auditList || [];
    }).catch((e) => {
      this.$message.error(e.message);
    });
  },
  methods: {
    toggleStatusUp(row) {
      row.status_up = row.status_up === 1 ? 2 : 1;
      this.editStatusUp(row);
    },
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    queryFinance() {
      this.$http.get('/Finance/getFinanceList').then((res) => {
        if (res.data.code === 0) {
          this.financeList = res.data.data || [];
        }
      }).catch(() => {});
    },
    reset() {
      this.where = {
        finance_id: '',
        account_name: '',
        time: '',
        audit_status: ''
      };
      this.reload();
    },
    openDetail(row) {
      this.detailData = { ...row };
      this.showDetail = true;
    },
    auditPass(row) {
      this.$confirm('确认审核通过该上线申请？通过后将自动上线。', '提示', { type: 'warning' })
        .then(() => this.postAudit(row, 1, ''))
        .catch(() => {});
    },
    auditReject(row) {
      this.$prompt('请输入', '拒绝审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        inputErrorMessage: '请填写拒绝原因'
      }).then(({ value }) => {
        this.postAudit(row, 2, value);
      }).catch(() => {});
    },
    postAudit(row, auditStatus, remark) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/resourcecolumn/audit', {
        id: row.id,
        audit_status: auditStatus,
        audit_remark: remark
      }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    getRowTypeCode(row) {
      const raw = row.type_code !== undefined && row.type_code !== null ? String(row.type_code).trim() : '';
      if (raw && TYPE_DIALOG[raw]) {
        return raw;
      }
      const bank = String(row.bank_name || '');
      if (bank.includes('微信')) return '2';
      if (bank.includes('支付宝')) return '3';
      if (row.qr_image || row.qr_code) {
        return bank.includes('微信') ? '2' : '3';
      }
      if (bank) return '1';
      return '';
    },
    openDialogByTypeCode(typeCode, row = null) {
      const key = String(typeCode);
      if (!TYPE_DIALOG[key]) {
        this.$message.warning('暂不支持该渠道类型的收款信息');
        return;
      }
      this.showEdit = false;
      this.activeEditType = '';
      this.$nextTick(() => {
        this.activeEditType = key;
        this.editData = row ? { ...row, type_code: key } : null;
        this.showEdit = true;
      });
    },
    openAdd(typeCode) {
      this.openDialogByTypeCode(typeCode, null);
    },
    openEdit(row) {
      const typeCode = this.getRowTypeCode(row);
      if (!typeCode) {
        this.$confirm('未记录渠道类型，请选择编辑模板', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '支付宝',
          cancelButtonText: '微信',
          type: 'info',
        }).then(() => {
          this.openDialogByTypeCode('3', row);
        }).catch((action) => {
          if (action === 'cancel') {
            this.openDialogByTypeCode('2', row);
          }
        });
        return;
      }
      this.openDialogByTypeCode(typeCode, row);
    },
    onEditDone() {
      this.showEdit = false;
      this.activeEditType = '';
      this.editData = null;
      this.reload();
    },
    openEdit2(row) {
      this.current2 = row;
      this.showEdit2 = true;
    },
    openRiskLimit(row) {
      const limitNum = Number(row.risk_limit);
      this.riskForm = {
        batch: false,
        id: row.id,
        ids: [row.id],
        account_label: [row.account_name, row.bank_name, row.account_number].filter(Boolean).join(' | '),
        sj_amount_to: row.sj_amount_to != null ? String(row.sj_amount_to) : String(row.sj_amount || '0.00'),
        risk_limit: Number.isFinite(limitNum) ? String(limitNum) : '0'
      };
      this.showRiskLimit = true;
      this.$nextTick(() => {
        if (this.$refs.riskForm) this.$refs.riskForm.clearValidate();
      });
    },
    openRiskLimitBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.riskForm = {
        batch: true,
        id: 0,
        ids: this.selection.map((d) => d.id),
        account_label: '',
        sj_amount_to: '',
        risk_limit: '0'
      };
      this.showRiskLimit = true;
      this.$nextTick(() => {
        if (this.$refs.riskForm) this.$refs.riskForm.clearValidate();
      });
    },
    saveRiskLimit() {
      this.$refs.riskForm.validate((valid) => {
        if (!valid) return;
        this.riskSaving = true;
        const id = this.riskForm.batch ? this.riskForm.ids : this.riskForm.id;
        this.$http.post('/resourcecolumn/setRiskLimit', {
          id,
          risk_limit: this.riskForm.risk_limit
        }).then((res) => {
          this.riskSaving = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.showRiskLimit = false;
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.riskSaving = false;
          this.$message.error(e.message);
        });
      });
    },
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/resourcecolumn/delete', { id: row.id }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.$confirm('确定要删除选中的数据吗?', '提示', { type: 'warning' }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/resourcecolumn/delete', {
          id: this.selection.map((d) => d.id)
        }).then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    initData() {
      this.$confirm('初始化将清空全部资源数据且不可恢复，确定继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/resourcecolumn/initData').then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.selection = [];
            this.getResourceName();
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    getResourceName() {
      this.$http.post('/resourcecolumn/getResourceName').then((res) => {
        if (res.data.code === 0) {
          this.accountNameList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.$message.error(e.message);
      });
    },
    postStatus(url, row, payload, revertKey) {
      const loading = this.$loading({ lock: true });
      this.$http.post(url, payload).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          row[revertKey] = row[revertKey] === 1 ? 2 : 1;
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        row[revertKey] = row[revertKey] === 1 ? 2 : 1;
        this.$message.error(e.message);
      });
    },
    editStatusUp(row) {
      this.postStatus('/resourcecolumn/statusup', row, { id: row.id, status_up: row.status_up }, 'status_up');
    }
  }
};
</script>

<style scoped>
.dict-cell-clickable {
  cursor: pointer;
  display: inline-block;
}
.dict-cell-clickable.is-disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
</style>
